import { useError, useLoader, useNotification, useRefetch, useUpdateCommunity } from "@piiqtechnologies/ui-lib";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { PeekButton, PeekDialog, PeekDialogActions, PeekDialogContent, PeekStack, PeekTextField, PeekTypography, } from "@piiqtechnologies/ui-components";
const DEACTIVATE_CONFIRM_KEY = "deactivate";
export function DeactivateCommunityForm({ onClose, onDeactivationSuccessful, communityId, }) {
    const intl = useIntl();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setRefetch } = useRefetch();
    const { setNotification } = useNotification();
    const [deactivateKey, setDeactivateKey] = useState("");
    const [deactivateCommunity, communityDeactivated, communityDeactivationLoading, communityDeactivationError] = useUpdateCommunity();
    const onChangeDeleteKey = (event) => {
        setDeactivateKey(event.target.value);
    };
    const handleDeactivateCommunityForm = () => {
        deactivateCommunity({
            _id: communityId,
            isActive: false,
        });
    };
    useEffect(() => {
        setLoader(communityDeactivationLoading, "communityDeactivationLoading");
        return () => setLoader(false, "communityDeactivationLoading");
    }, [communityDeactivationLoading]);
    useEffect(() => {
        if (communityDeactivationError) {
            setError(communityDeactivationError === null || communityDeactivationError === void 0 ? void 0 : communityDeactivationError.message);
        }
    }, [communityDeactivationError]);
    useEffect(() => {
        if (communityDeactivated) {
            setNotification(intl.formatMessage(messages.deactivateCommunityFormSuccess));
            onDeactivationSuccessful();
            setRefetch();
        }
    }, [communityDeactivated]);
    return (React.createElement(PeekDialog, { disablePortal: true, maxWidth: "sm", hasCloseIcon: true, title: "Deactivate Community", open: true, onClose: onClose },
        React.createElement(PeekDialogContent, null,
            React.createElement(PeekStack, { spacing: 1 },
                React.createElement(PeekTypography, { variant: "body1" }, intl.formatMessage(messages.deactivateCommunityFormDescription, { deactivateKey: DEACTIVATE_CONFIRM_KEY })),
                React.createElement(PeekTextField, { variant: "standard", value: deactivateKey, onChange: onChangeDeleteKey, InputLabelProps: { required: true }, InputProps: {
                        placeholder: DEACTIVATE_CONFIRM_KEY,
                        disableUnderline: true,
                        "aria-label": DEACTIVATE_CONFIRM_KEY,
                    } }))),
        React.createElement(PeekDialogActions, null,
            React.createElement(PeekButton, { fullWidth: true, size: "large", disabled: deactivateKey.toLocaleLowerCase() !== DEACTIVATE_CONFIRM_KEY, onClick: handleDeactivateCommunityForm, color: "error", variant: "contained" }, intl.formatMessage(messages.communityUpdateDeactivation)))));
}
